{
  "version": 1,
  "asset_id": "ac95840a-8614-4395-8196-da51ec11d5ef",
  "project_id": "9f205a2e-8c62-436c-9ba0-eb8567773752",
  "url": "/__l5e/assets-v1/ac95840a-8614-4395-8196-da51ec11d5ef/how-it-works-hero-960.webp",
  "r2_key": "a/v1/9f205a2e-8c62-436c-9ba0-eb8567773752/ac95840a-8614-4395-8196-da51ec11d5ef/how-it-works-hero-960.webp",
  "original_filename": "how-it-works-hero-960.webp",
  "size": 48148,
  "content_type": "image/webp",
  "created_at": "2026-07-22T22:51:27Z"
}
